module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Reset"
  }, [_c('h3', {
    staticClass: "title",
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    }
  }, [_vm._v("找回密码")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('router-view')], 1), _vm._v(" "), _c('p', {
    staticClass: "_line"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fd36988"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/Reset.vue
// module id = 770
// module chunks = 1